import React, { useState } from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

const defaultTabs = ['Home', 'About', 'Blog']

export function TabTransition({ values = {} }: { values?: FieldValues }) {
  const [active, setActive] = useState(0)
  const stiffness = values.stiffness ?? 400
  const damping = values.damping ?? 30
  const fadeDuration = values.fadeDuration ?? 0.2
  const yOffset = values.yOffset ?? 8
  const tabs = defaultTabs

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4">
      <div className="flex gap-1 bg-gray-100 rounded-lg p-1 relative">
        {tabs.map((tab, i) => (
          <button
            key={tab}
            onClick={() => setActive(i)}
            className="relative px-4 py-1.5 text-xs font-medium cursor-pointer z-10"
          >
            {active === i && (
              <motion.div
                layoutId="tab-indicator"
                className="absolute inset-0 bg-white rounded-md shadow-sm"
                transition={{ type: 'spring', stiffness, damping }}
              />
            )}
            <span className={`relative z-10 ${active === i ? 'text-gray-900' : 'text-gray-500'}`}>
              {tab}
            </span>
          </button>
        ))}
      </div>
      <motion.div
        key={active}
        initial={{ opacity: 0, y: yOffset }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: fadeDuration }}
        className="text-[10px] text-gray-400"
      >
        {tabs[active]} content
      </motion.div>
    </div>
  )
}
